import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["attribute", "limit", "showMore", "showMoreLimit", "sortBy", "transformItems"];
import React from 'react';
import { useMenu } from 'react-instantsearch-hooks';
import { Menu as MenuUiComponent } from "../ui/Menu.js";
export function Menu(_ref) {
  var attribute = _ref.attribute,
      limit = _ref.limit,
      showMore = _ref.showMore,
      showMoreLimit = _ref.showMoreLimit,
      sortBy = _ref.sortBy,
      transformItems = _ref.transformItems,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useMenu = useMenu({
    attribute: attribute,
    limit: limit,
    showMore: showMore,
    showMoreLimit: showMoreLimit,
    sortBy: sortBy,
    transformItems: transformItems
  }, {
    $$widgetType: 'ais.menu'
  }),
      canToggleShowMore = _useMenu.canToggleShowMore,
      isShowingMore = _useMenu.isShowingMore,
      items = _useMenu.items,
      refine = _useMenu.refine,
      createURL = _useMenu.createURL,
      toggleShowMore = _useMenu.toggleShowMore;

  var uiProps = {
    items: items,
    createURL: createURL,
    onRefine: function onRefine(item) {
      return refine(item.value);
    },
    canToggleShowMore: canToggleShowMore,
    onToggleShowMore: toggleShowMore,
    isShowingMore: isShowingMore
  };
  return /*#__PURE__*/React.createElement(MenuUiComponent, _extends({}, props, uiProps, {
    showMore: showMore
  }));
}